if (!customElements.get('rebuy-recommendations')) {
  class RebuyRecommendations extends HTMLElement {
    constructor() {
      super()
      this.swiper = null
    }

    connectedCallback() {
      this.gridContainer = this.querySelector('.js-rebuy-recommendations-grid')
      this.listElements = this.gridContainer.querySelectorAll('li')
      this.swiperElement = this.querySelector('.js-swiper')
      this.init()
      this.fetchRecommendations()
    }

    init() {
      const swiperNextButton = this.querySelector('.js-swiper-button-next')
      const swiperPrevButton = this.querySelector('.js-swiper-button-prev')

      if (!this.swiperElement) return
      this.swiper = new Swiper(this.swiperElement, {
        slidesPerView: 1.4,
        spaceBetween: 10,
        loop: false,
        lazy: true,
        mousewheel: false,
        breakpoints: {
          500: {
            slidesPerView: 2.4,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3.4,
            spaceBetween: 10,
          },
          992: {
            slidesPerView: 4.4,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: 5.4,
            spaceBetween: 10,
          },
        },
        navigation: {
          nextEl: swiperNextButton,
          prevEl: swiperPrevButton,
        },
        on: {
          afterInit: () => {
            setTimeout(() => {
              swiperPrevButton.classList.remove('loading')
              swiperNextButton.classList.remove('loading')
            }, 100)
          },
        },
      })
    }

    async fetchRecommendations() {
      const ruleId = this.dataset.ruleId
      const productId = this.dataset.productId
      const requestParameters = new URLSearchParams({
        format: 'pretty',
        limit: 10,
        country_code: this.dataset.countryCode,
        key: 'ed337d3352363ba1d5d352174caaa7a7008da887',
        shopify_product_ids: productId,
      })
      try {
        const response = await fetch(
          `https://rebuyengine.com/api/v1/custom/id/${ruleId}?${requestParameters.toString()}`,
        )
        const reponse = await response.json()
        this.renderRecommendations(reponse.data)
      } catch (error) {
        this.classList.add('visually-hidden')
        console.error(error)
      }
    }

    renderRecommendations(data) {
      if (data.length === 0) {
        this.classList.add('visually-hidden')
        return
      }

      const fetchPromises = data.map(async (product, index) => {
        const productCardResponse = await fetch(`${product.link}?view=card`)
        const htmlSection = await productCardResponse.text()
        const html = new DOMParser().parseFromString(htmlSection, 'text/html')
        const li = html.querySelector('li')
        li.dataset.index = index
        this.listElements[index].classList.remove('rebuy-recommendations__skeleton')
        this.listElements[index].innerHTML = li.innerHTML
      })

      // Wait for all fetches to complete, then remove remaining skeletons
      Promise.all(fetchPromises).then(() => {
        this.removeRemainingSkeletons()
      })
    }

    removeRemainingSkeletons() {
      this.listElements.forEach((element) => {
        if (element.classList.contains('rebuy-recommendations__skeleton')) {
          element.remove()
        }
      })
    }
  }
  customElements.define('rebuy-recommendations', RebuyRecommendations)
}
